import React from "react";
import { Row, Col, Container, Image, Card } from "react-bootstrap";
import BlogBanner from "../Images/Blog Banner1.png";
import "./Blogs.css";

import mealPrep from "../Images/b1.png";
import nutritionGuide from "../Images/b2.png";
import hydration from "../Images/b3.png";

const blogs = [
  {
    image: mealPrep,
    title: "Save Time and Eat Healthy",
    description:
      "Discover delicious and nutritious meal prep ideas, including breakfast, lunch, and dinner options.",
  },
  {
    image: nutritionGuide,
    title: "A Nutritionist's Guide",
    description:
      "Strengthen your immune system with these powerful foods and lifestyle habits.",
  },
  {
    image: hydration,
    title: "Hydrate Your Way to Health",
    description:
      "Learn how much water you should drink daily and tips for making water more flavorful.",
  },
];

function Blogs() {
  return (
    <div>
      <Image src={BlogBanner} alt="Blog Banner" className='Banner-Img'/>
      <Container fluid className="blogs-page py-5">
        <Row className="justify-content-center">
          <Col lg={11}>

            <Card className="blogs-main-card border-0 shadow-lg rounded-4 p-4 p-md-5">

              {/* Heading */}
              <div className="text-center mb-5">
                <h1 className="blogs-heading">
                  Latest Health & Nutrition Insights
                </h1>

                <p className="blogs-intro">
                  Discover evidence-based nutrition advice, wellness tips,
                  healthy recipes, and lifestyle guidance to help you build
                  sustainable habits and achieve your health goals.
                </p>
              </div>

              {/* Blog Cards */}
              <Row className="g-4">
                {blogs.map((blog, index) => (
                  <Col lg={4} md={6} sm={12} key={index}>
                    <div className="blog-card">

                      <Image
                        src={blog.image}
                        alt={blog.title}
                        className="blog-image"
                        fluid
                      />

                      <h3 className="blog-title">
                        {blog.title}
                      </h3>

                      <p className="blog-description">
                        {blog.description}
                      </p>

                    </div>
                  </Col>
                ))}
              </Row>

            </Card>

          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Blogs;